import { Component } from '@angular/core';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
})
export class HomeComponent {
    fields = '';
}



// WEBPACK FOOTER //
// /home/ubuntu/spina-me/source/src/app/home/home.component.ts